import { jsx as _jsx } from "react/jsx-runtime";
import { useMessageContext } from "./MessageContext.js";
import { usePlasmicCanvasContext } from "@plasmicapp/host";
export const LGPresetMessageProps = {
    preset: {
        type: "choice",
        options: [
            "INVALID_LINK",
            "PROSPECT_SAVE_ERROR",
            "PROSPECT_VALIDATION_ERROR",
            "PURCHASE_REJECTED",
            "PURCHASE_ERROR",
        ],
        defaultValue: "INVALID_LINK",
        displayName: "Preset",
    },
    content: {
        type: "string",
        displayName: "Message Content",
    },
    isDynamic: {
        type: "boolean",
        displayName: "Is Dynamic",
        description: "If true, the message will only be shown when the preset matches the one defined by current message context",
        defaultValue: false,
    },
};
export function LGPresetMessage({ preset, content, isDynamic, className }) {
    const { message } = useMessageContext();
    //TODO: this stopped working after some of the recent updates, need to investigate and fix it:
    const inEditor = usePlasmicCanvasContext();
    if (!inEditor) {
        if (isDynamic) {
            if (message?.messageType !== "preset" || message?.preset !== preset) {
                return null;
            }
        }
        else if (!content) {
            return null;
        }
    }
    //TODO: implement auto-hiding after a few seconds?
    return (_jsx("div", { className: `${className} lg-message lg-message-preset-${preset.toLowerCase()}`, children: content }));
}
